import React,{useState} from 'react'
import "../App.css";
import { useNavigate } from "react-router-dom";

const Input = () => {
  const [KeyValue, setKeyValue] = useState('');
  const [userInput, setUserInput] = useState('');
  const navigate = useNavigate();

  const handleChange1 = (e) => {
    setKeyValue(e.target.value);
  };

  const handleChange2 = (e) => {
    setUserInput(e.target.value);
  };

  const firstpage = () => {
    navigate("/");
  };

  const secondpage = () => {
    navigate('/initial', { state: {hexkey, hexuserInput, KeyValue, userInput } });
  };

  const stringToHexadecimal = (input) => {
    let result = '';
    for (let i = 0; i < 16; i++) {
      const char = input[i] ? input.charCodeAt(i).toString(16).toUpperCase() : '00';
      result += char.padStart(2, '0');
      if (i < 15) {
        result += ' '; // Add a space between every two characters
      }
    }
    return result;
  };
  

  const hexkey = stringToHexadecimal(KeyValue);
  const hexuserInput =  stringToHexadecimal(userInput);


  return (
    <div className="input-container">
      <div className="flex flex-col items-center">
        <div>
          <h1 className="text-3xl pt-8">Experiment 7 : Encryption of plaintext using Twofish algorithm</h1>
        </div>

        <div className="pt-10">
          <h1>Enter the Plaintext to be Encrypted in ascii (max length 16)</h1>
          <br />

        </div>
        <div class="input-box">
        <input 
          maxLength="16" 
          className='border-solid border-3 bg-slate-100 px-2 py-2 rounded-md' 
          type="text"
          placeholder='Enter 16 char long ascii string' 
          value={userInput}
          onChange={handleChange2}/>
          <br /><br />

        </div> 

        <div className="pt-10">
          <h1>Enter the Encryption Key in ascii (max length 16)</h1>
          <br />

        </div>
        <div class="input-box">
        <input 
          maxLength="16" 
          className='border-solid border-3 bg-slate-100 px-2 py-2 rounded-md' 
          type="text"
          placeholder='Enter any alphanumeric value' 
          value={KeyValue}
          onChange={handleChange1}/>
          <br /><br />

        </div> 
       

        <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
            PREVIOUS
          </div>
          <div className="next-button" onClick={secondpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Input